export enum ModeEnum {
  Easy = 'easy',
  Medium = 'medium',
  Hard = 'hard',
}
